import type { ClientTenantStatus } from '@bluesphere/api-client';

/**
 * Whether a Client is in service: consented to Defender, or `active`, engaged
 * without MDR and so with no consent to wait for (design r17, task 224).
 * Mirrors `ClientTenant.is_active` in the data-access layer.
 */
export function isInService(tenant: { status: ClientTenantStatus }): boolean {
  return tenant.status === 'consented' || tenant.status === 'active';
}
